export default function checkAllowedDomain(url: string, allowedDomains: string[]): boolean {
  const endpoint = new URL(url);
  for (let i = 0; i < allowedDomains.length; i += 1) {
    if (endpoint.hostname.endsWith(allowedDomains[i])) {
      return true;
    }
  }

  return false;
}
